import { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { useAuth } from '../contexts/AuthContext';

// Hook CRUD genérico sobre un recurso REST (/clientes, /productos, ...).
export default function useEntity(recurso, opciones = {}) {
  const { usuario, empresaActivaId } = useAuth();
  const [items, setItems] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const paramsSignature = JSON.stringify(opciones?.params || {});

  const cargar = useCallback(async () => {
    setCargando(true);
    setError('');
    try {
      const params = {
        ...(usuario?.rol === 'superadmin' && empresaActivaId ? { empresaId: empresaActivaId } : {}),
        ...(opciones?.params || {}),
      };
      const { data } = await api.get(`/${recurso}`, { params });
      setItems(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al cargar');
    } finally {
      setCargando(false);
    }
  }, [recurso, usuario, empresaActivaId, paramsSignature]);

  useEffect(() => { cargar(); }, [cargar]);

  const crear = async (datos) => {
    // Superadmin debe pasar empresaId explícitamente
    const payload = usuario?.rol === 'superadmin' && empresaActivaId
      ? { ...datos, empresaId: empresaActivaId }
      : datos;
    const { data } = await api.post(`/${recurso}`, payload);
    setItems((prev) => [data, ...prev]);
    return data;
  };

  const actualizar = async (id, datos) => {
    const { data } = await api.put(`/${recurso}/${id}`, datos);
    setItems((prev) => prev.map((i) => (i._id === id ? data : i)));
    return data;
  };

  const eliminar = async (id) => {
    await api.delete(`/${recurso}/${id}`);
    setItems((prev) => prev.filter((i) => i._id !== id));
  };

  return { items, cargando, error, cargar, crear, actualizar, eliminar, setItems };
}
